module.exports = __webpack_public_path__ + "static/media/lend_usdt.36389536.svg";